module.exports = __webpack_public_path__ + "static/media/edit.bdc9bdd0.svg";